import {BlockUiService} from '../../services/blockui.service';
import {ReportService} from '../../services/report.service';
import {DatePipe, CurrencyPipe, DecimalPipe} from '@angular/common';
import {Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ComponentRef, ComponentFactoryResolver, ViewContainerRef, ViewChild} from '@angular/core';


@Component({
	selector: 'app-frantishex-table',
	templateUrl: './frantishex-table.component.html',
	styleUrls: ['./frantishex-table.component.scss']
})
export class FrantishexTableComponent implements OnInit, OnChanges {



	/**
	 * column definition. Exepcted format is
	 * [
	 * {title, name, className, rowClassName, dataType, filtering: {placeholder: 'Filter by position'} },
	 * ]
	 * dataType is one of date, dateTime, currency,  boolean
	 */
	@Input() columns: Array<any>;
	@Input() rows: Array<any>;
	@Input() remoteReportName: string;

	// general confic
	@Input() paging = true;
	@Input() sorting = true;
	@Input() filtering = false;
	@Input() rowClickable = false;
	@Input() allowDeletion = false;
	@Input() allowUpgrade = false;
	@Input() allowDowngrade = false;
  @Input() allowWarning = false;
	@Input() allowEdit = false;
	@Input() allowNew = false;
  @Input() rowOtgovornik = false;

	// paging config
	@Input() itemsPerPage = 15;
	@Input() maxPages = 20;

	// styling configs
	@Input() tableClassName = 'table table-bordered frx-table-striped ';

	@Input() defaultSortColumn = '';
	@Input() defaultSortOrder = 'desc';

	// expander config
	@Input() expandedComponent: any;
	@ViewChild('dynamicChild', {read: ViewContainerRef})
	target: ViewContainerRef;



	// events
	@Output() onTableChange = new EventEmitter();
	@Output() onRowClicked = new EventEmitter();
	@Output() expanderClicked = new EventEmitter();
	@Output() deleteClicked = new EventEmitter();
	@Output() upgradeClicked = new EventEmitter();
	@Output() downgradeClicked = new EventEmitter();
	@Output() objectEditSaved = new EventEmitter();
	@Output() objectEditCacelled = new EventEmitter();


	// internal properties
	page = 1;

	itemsOnCurrentPage: Array<any>;
	totalItems = 0;

	public remoteMode = false;

	private currentExpander;
	public currentExpandedRow;

	currentlyEditedRowIndex: number;
	currentlyEditedRow: any;

	public editedFields = [];

	constructor(private decimalPipe: DecimalPipe, private datePipe: DatePipe,
		private blockUi: BlockUiService,
		private componentFactoryResolver: ComponentFactoryResolver, private vcRef: ViewContainerRef,
		private reportService: ReportService) {}

	ngOnInit() {
		this.loadReportMetadataBackend();
	}


	private loadReportMetadataBackend() {
		if (this.remoteMode || !this.remoteReportName) {
			return;
		}
		this.remoteMode = true;
		this.blockUi.start(this.vcRef);
	}

	ngOnChanges(changes: SimpleChanges) {
		if (this.remoteReportName) {
			this.loadReportMetadataBackend();
		} else {
			this.refresh();
		}

	}

	public getCellData(row, column) {
		const data = row[column.name];
		if (data == null && column.dataType !== 'self' || data === '') {
			return '';
		}
		if (!column || !column.dataType) {
			return data;
		}
		if (column.dataType.toLowerCase() === 'date') {
			return this.datePipe.transform(new Date(data), 'dd.MM.yyy');
		} else if (column.dataType.toLowerCase() === 'datetime') {
			return this.datePipe.transform(new Date(parseInt('' + data, 10)), 'yyyy-MM-dd HH:mm');
		} else if (column.dataType.toLowerCase() === 'dateasarray') {
			return this.datePipe.transform(
				new Date(data[0], data[1] - 1, data[2], 0, 0, 0, 0)
				, 'yyyy-MM-dd');
		} else if (column.dataType.toLowerCase() === 'datetimeasarray') {
			const dateTime = new Date(data[0], data[1] - 1, data[2], data[3] ? data[3] : 0, data[4] ? data[4] : 0, 0, 0);
			return this.datePipe.transform(dateTime, 'yyyy-MM-dd HH:mm');
		} else if (column.dataType.toLowerCase() === 'hourasarray') {
			return data[0] + ':' + data[1];
		} else if (column.dataType.toLowerCase() === 'currency') {
			return "€ " + this.decimalPipe.transform(data, '1.2-2');
		} else if (column.dataType.toLowerCase() === 'boolean') {
			return data ? 'Yes' : 'No';
		} else if (column.dataType.toLowerCase() === 'self') {
			return row;
		} else if (column.dataType.toLowerCase() === 'complex' && column.complexDataType.list) {
			const list: Array<any> = column.complexDataType.list;
			let res = '';
			list.forEach(element => {
				if (element[column.complexDataType.key] === data) {
					res = element[column.complexDataType.displayValue];
				}
			});
			return res;
		} else if (column.dataType.toLowerCase() === 'object' && column.complexDataType.object) {
			const object = data;
			let res = '';
			res = object[column.complexDataType.displayValue];
			return res;
		}
		return data;
	}

	getAdditionalClass(column) {
		if (column && column.dataType && column.dataType.toLowerCase() === 'currency') {
			return 'currency-cell';
		}
		if (column && column.dataType && column.dataType.toLowerCase() === 'text-overflow') {
			return 'text-overflow';
		}
		return '';
	}


	public setData(data: Array<any>) {
		this.rows = data;
		this.refresh();
	}

	public refresh() {
		this.onChangeTable();
	}

	public onChangeTable(): any {
		this.closeExapndingComponent();
		if (!this.remoteMode) {
			let data = this.rows;
			data = this.filterData(data);
			data = this.sortData(data);
			const totalItems = data.length;
			data = this.paginateData(data);
			this.finishLoadingData(data, totalItems);
		} else {
			this.loadPageFromBackend();
		}
	}


	private loadPageFromBackend() {
		const parameters = this.constructBackedCallParameters();
		this.blockUi.start(this.vcRef);
	}

	//	public extractExcel() {
	//		const parameters = this.constructBackedCallParameters();
	//		delete parameters['page'];
	//		delete parameters['pageSize'];
	//		this.blockUi.start(this.vcRef);
	//		this.reportService.executeXLSReport(this.remoteReportName, parameters).subscribe(
	//			data => {
	//				this.blockUi.stop();
	//				this.downloadFile(data);
	//			},
	//			error => {
	//				this.blockUi.stop();
	//			});
	//	}


	downloadFile(data: Response) {
		const blob = new Blob([data.blob()], {type: 'application/vnd.ms-excel'});
	}

	private constructBackedCallParameters() {
		const parameters = {};
		if (this.filtering) {
			this.columns.forEach((column: any) => {
				if (column.filtering) {
					if (column.filtering.filterString) {
						parameters[column.name] = column.filtering.filterString;
					}
					if (column.filtering.filterFromDate) {
						parameters[column.name + '_from'] = '' + column.filtering.filterFromDate.getTime();
					}
					if (column.filtering.filterToDate) {
						const date = column.filtering.filterToDate;
						date.setDate(date.getDate() + 1);
						parameters[column.name + '_to'] = '' + date.getTime();
					}
				}
			});
		}
		parameters['page'] = this.page;
		parameters['pageSize'] = this.itemsPerPage;
		if (this.sorting) {
			const column = this.getSortColumn();
			if (column) {
				parameters['sortColumn'] = column.name;
				parameters['sortOrder'] = column.sort;
			}
		}
		return parameters;
	}

	private finishLoadingData(data, totalItems) {
		this.totalItems = totalItems;
		this.itemsOnCurrentPage = data;
		this.onTableChange.emit(data);
		this.editCancel();
	}

	public editSave() {
		// validate
		for (let i = 0; i < this.columns.length; i++) {
			const column = this.columns[i];
			const value = this.currentlyEditedRow[column.name];
			if (column.dataType && (column.dataType.toLowerCase() === 'currency' || column.dataType.toLowerCase() === 'integer') && isNaN(value)) {
				alert('Please provide a valid number for field ' + column.title);
				return;
			}
		}
		this.objectEditSaved.emit(this.currentlyEditedRow);
		this.refresh();
	}

	public editCancel() {
		if (this.currentlyEditedRow) {
			this.objectEditCacelled.emit(this.currentlyEditedRow);
			if (this.currentlyEditedRow._frxTableIsNew) {
				this.itemsOnCurrentPage = this.itemsOnCurrentPage.slice(1, this.itemsOnCurrentPage.length);
			}
		}
		this.currentlyEditedRowIndex = null;
		this.currentlyEditedRow = null;
	}

	public addRow() {
		this.editCancel();
		this.currentlyEditedRowIndex = 0;
		this.currentlyEditedRow = {_frxTableIsNew: true};
		this.itemsOnCurrentPage = [this.currentlyEditedRow].concat(this.itemsOnCurrentPage);
	}

	public edit(row, index) {
		this.editCancel();
		this.currentlyEditedRowIndex = index;
		this.currentlyEditedRow = JSON.parse(JSON.stringify(row)); // quick and dirty copy
	}

	public delete(row) {
		this.deleteClicked.emit(row);
	}

	public upgrade(row) {
		this.upgradeClicked.emit(row);
	}

	public downgrade(row) {
		this.downgradeClicked.emit(row);
	}

	public changeSortForColumnName(columnName, sortType) {
		let column = null;
		for (let i = 0; i < this.columns.length; i++) {
			if (this.columns[i].name === columnName) {
				column = this.columns[i];
				break;
			}
		}
		if (column === null) {
			console.log('No Column with name ' + columnName);
			return;
		}
		this.changeSortInernal(column, sortType);
	}

	private changeSort(column) {
		if (column.sort === 'asc') {
			this.changeSortInernal(column, 'desc');
		} else {
			this.changeSortInernal(column, 'asc');
		}
	}

	private changeSortInernal(column, newSort) {
		if (!this.sorting) {
			return;
		}
		if (newSort === 'desc') {
			column.sort = 'desc';
			column.sortSymbol = '▼';
		} else {
			column.sort = 'asc';
			column.sortSymbol = '▲';
		}
		this.columns.forEach((clm: any) => {
			if (clm.name !== column.name) {
				clm.sort = '';
				clm.sortSymbol = '';
			}
		});
		this.onChangeTable();
	}


	private changeFilter(column) {
		if (this.filtering) {
			this.onChangeTable();
		}
	}

	private paginateData(data: any) {
		if (!this.paging) {
			return data;
		}
		let startItem = this.itemsPerPage * (this.page - 1);
		if (data.length != this.totalItems) {
			startItem = 0;
		}
		if (this.totalItems > 0) {
			//			if (this.totalItems === startItem) {
			//				this.page = this.page - 1;
			//				startItem = this.itemsPerPage * (this.page - 1);
			//			}
		}
		return data.slice(startItem, startItem + this.itemsPerPage);
	}
	
	private formatDate(dateToFormat): Date {
        if (dateToFormat) {
          const dateParts = dateToFormat.split('.');
          return new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
        }
        return;
      }
	
	private sortData(data: any): any {
		if (!this.sorting) {
			return data;
		}
		const column = this.getSortColumn();
		if (!column) {
			return data;
		}
        const columnName = column.name;
        const sort = column.sort;
        
        //sort by date if selected column is date
        if ( columnName === "dataNasrochen" || columnName === "deadlineString" ) {
            return data.sort(( previous, current ) => {
                let previousDate = this.formatDate(previous[columnName]);
                let currentDate = this.formatDate(current[columnName]);

                if ( previousDate > currentDate ) {
                    return sort === 'desc' ? -1 : 1;
                } else if ( previousDate < currentDate ) {
                    return sort === 'asc' ? -1 : 1;
                }
                return 0;
            } );
        }
        //simple sorting
        else {
            return data.sort(( previous, current ) => {
                if ( previous[columnName] > current[columnName] ) {
                    return sort === 'desc' ? -1 : 1;
                } else if ( previous[columnName] < current[columnName] ) {
                    return sort === 'asc' ? -1 : 1;
                }
                return 0;
            } );
        }
	}

	private getSortColumn() {
		const columns = this.columns || [];
		for (let i = 0; i < columns.length; i++) {
			if (columns[i].sort && columns[i].sort !== '') {
				return columns[i];
			}
		}
		return null;
	}


	private filterData(data: any): any {
		let filteredData: Array<any> = data;
		if (!this.filtering) {
			return filteredData;
		}

		this.columns.forEach((column: any) => {
			if (column.filtering) {
				filteredData = filteredData.filter((item: any) => {
					return !column.filtering.filterString || (item[column.name] && item[column.name].toLowerCase().match(column.filtering.filterString.toLowerCase()));
				});
			}
		});

		return filteredData;
	}




	private pageChanged(event) {
		this.page = event.page;
		this.onChangeTable();
	}

	private rowClicked(row, rowIndex) {
		this.openExapndingComponent(row, rowIndex);
		const event = {'row': row};
		this.onRowClicked.emit(event);
	}

	private openExapndingComponent(row, rowIndex) {
		if (!this.expandedComponent) {
			return;
		}
		this.closeExapndingComponent();
		if (row === this.currentExpandedRow) {
			this.currentExpandedRow = null;
			return;
		}
		const expandingData = document.querySelector('.expanding-data');
		const expandingRow = document.querySelector('.expanding-row-' + rowIndex);
		this.currentExpandedRow = row;
		expandingRow.appendChild(expandingData);
		this.expanderClicked.emit(row);
		const factory = this.componentFactoryResolver.resolveComponentFactory(this.expandedComponent);
		this.currentExpander = this.target.createComponent(factory);
		this.currentExpander.changeDetectorRef.detectChanges();
	}

	private closeExapndingComponent() {
		if (this.currentExpander) {
			this.currentExpander.destroy();
		}
		// bring him home
		const expandingData = document.querySelector('.expanding-data');
		const expandingRow = document.querySelector('.expanding-data-storage');
		expandingRow.appendChild(expandingData);
	}

	getHeaderClass(column) {
		if (column.dataType && (column.dataType.toLowerCase() === 'datetime' || column.dataType.toLowerCase() === 'date')) {
			return 'header-date';
		}
		return 'header-regular';
	}
}
